<template>
  <div class="wrapper-menu wh100p">
    <section class="section-navs df-c-sb">
      <div class="back-btn _themecolor f-m df-c-ct" @click="$router.go(-1)">
        <img class="arrow" :src="iconArrowLeft">
        <div>{{$t('calc.calcWay')}}</div>
      </div>
      <div class="cancel-btn df-c-ct">
        <div class="whitebtn" @click="cancelOrderClick">
          {{[8,9,10,100].includes(orderData.status)?$t('calc.cancelCalcAndRefund'):$t('food.cancelCalc')}}
        </div>
      </div>
      <div class="code f1 _themecolor df-c-sb f-bold">
        <div class="f1 df-c-ct f-l" v-if="orderData.code">{{orderData.code+(orderData.showNo>1?('-'+orderData.showNo):'')}}</div>
        <div class="f1 df-c-ct f-l" v-else-if="orderData.orderNo">{{$t('order.orderNo')}}：{{orderData.orderNo}}</div>
        <div class="f1 df-c-fe">
          <div class="whitebtn mr20" @click="navToMenu" v-if="orderData.status===1">{{$t('order.backMenu')}}</div>
        </div>
      </div>
    </section>
    <section class="section-con df-l-fs">
      
      <div class="section-scroll f1 df-l-fs">
        <div class="df-c-sb mb20">
          <div class="df" v-if="isShowCouponChange&&isShowMember">
            <div class="df-c-ct" v-if="customer.customerId">
              <div class="f-s" style="margin-right:10px;">{{$t('member.memberAccount')}}：{{customer.customerName}}</div>
              <img
                class="rotate45" style="width:24px;height:24px;margin-right:12px;"
                src="@/assets/icons/add1.png" @click="clearOrderCustomer(orderData.id)" />
            </div>
            <div class="themebtn-s" @click="bindOrderCustomer(orderData.id)" v-else>{{$t('member.bindMember')}}</div>
          </div>
          <div v-else></div>
          <div class="df">
            <div class="f-s pad">{{$t('order.orderNo')+'：'}}{{orderData.orderNo|tothousands}}</div>
            <div class="f-s pad" v-if="orderData.code">{{$t('home.tableNo')+'：'+orderData.code+(orderData.showNo>1?('-'+orderData.showNo):'')}}</div>
          </div>
        </div>
        <!-- 优惠券 -->
        <div class="section-coupon df-sb">
          <div class="left df-c-fs">
            <div class="df-c-fs" @click="openCouponsSelectDialog2()">
              <img style="width:24px;height:24px;margin-right:12px;" src="@/assets/icons/discount.png" />
              <div class="f-m">{{$t('coupon.discountCode')}}</div>
            </div>
          </div>
          <div class="right">
            <div class="df-l-fs ai-fe" v-for="(x,i) in coupons" :key="i">
              <div class="df-c-fs">
                <img
                  style="width:40px;height:40px;margin-right:20px;" :src="iconCheckCoupon"
                  @click="openCouponsSelectDialog(i)" v-if="customer.customerId&&!x.code" />
                <input
                  class="input f-xs"
                  :placeholder="$t('coupon.inputDiscountCode')"
                  v-model="x.code"
                  @focus="onFocus_forScan"
                  @blur="searchCoupon(i)"
                  :disabled="!isShowCouponChange||x.dis" />
              </div>
              <div class="w100p df-c-sb">
                <div class="text sls f-xs" :class="{'_themecolor':x.success,'_redcolor':!x.success}">{{x['desc'+_lang]}}</div>
                <template v-if="isShowCouponChange">
                  <img style="width:24px;height:24px;margin-left:20px;" :src="iconAdd2" @click="addCoupon(i,1)" />
                  <img style="width:24px;height:24px;margin-left:20px;" :src="iconSubtract2" @click="addCoupon(i,-1)" />
                </template>
              </div>
            </div>
          </div>
        </div>
        <!-- 购物车商品 -->
        <div class="section-items">
          <div class="item" v-for="(x,i) in cartItems" :key="i">
            <div class="df-c-sb">
              <div class="text w100p sls df-c-fs">
                <div class="sls f1">{{x['itemName'+_lang]}}</div>
                <div class="num">X{{x.count|tothousands}}</div>
                <div class="timeBox">
                  <span class="time f-xxs" v-if="isShowTimeOfPlaceOrders&&hasSendCookIds.includes(x.id)">{{x['sendToKitchenTimeText'+_lang]}}</span>
                </div>
              </div>
              <div class="price text">{{(x.count*x.itemPrice)|toprice(2)}}</div>
            </div>
            <CartItemDetail :item="x" :fontSize="14" />
          </div>
        </div>
      </div>
      <!-- 价格信息 -->
      <div class="section-total df-c-sb">
        <div>
          <div class="remarks" v-if="takeOutPickupDateText">{{$t('menu.pickupTime')}}：{{takeOutPickupDateText}}</div>
          <div class="remarks">{{$t('menu.remarks')}}：{{orderData|toremark(false)}}</div>
        </div>
        <div class="df-c-fe right">
          <div class="text pad f-xxs f-silvery">{{$t('common.price')}}：{{orderData.costOrigin|toprice(2)}}</div>
          <div class="text pad f-xxs f-silvery" v-if="orderData.packageFee">{{$t('common.packageFee')}}：{{orderData.packageFee|toprice(2)}}</div>
          <div class="text pad f-xxs f-silvery" v-if="orderData.serviceFee">{{$t('common.serviceFee')}}：{{orderData.serviceFee|toprice(2)}}</div>
          <div class="text pad f-xxs f-silvery" v-if="orderData.takeOutDiscountFee">{{$t('common.discounttakeaway')}}：-{{orderData.takeOutDiscountFee|toprice(2)}}</div>
          <div class="text pad f-xxs f-silvery" v-if="orderData.discountFee">{{$t('common.discount')}}：-{{orderData.discountFee|toprice(2)}}</div>
          <div class="text pad f-xxs f-silvery" v-if="sysEnv_x==='us'">{{$t('common.tax')}}({{shopConfig_m.consumptionTax}}%)：{{orderData.consumptionTax|toprice(2)}}</div>
          <div class="df-c-ct">
            <div class="text pad f-l f-bold f-silvery">{{$t('common.total')}}：</div>
            <div class="text f-l f-bold _redcolor">{{orderData.userCost|toprice(2)}}</div>
          </div>
        </div>
      </div>
      <!-- 结算按鈕 -->
      <div class="section-btns w100p df-c-sb" v-if="cartItems.length">
        <div class="f1">
          <div class="whitebtn" @click="printOrderClick">{{$t('common.printOrder')}}</div>
        </div>
        <div class="f1 df-c-sa" v-if="orderData.status!==100">
          <template v-if="isShowOtherCalc&&shopConfig_m.partPay_b">
            <div class="whitebtn btn mr10" @click="tapCalcway('money')">{{$t('calc.calcWay2')}}</div>
            <div class="whitebtn btn mr10" @click="tapCalcway('food')">{{$t('calc.calcWay3')}}</div>
          </template>
          <template v-else>
            <div class="btn"></div>
            <div class="btn"></div>
          </template>
          <div class="themebtn btn" @click="tapCalcway('pay')">{{$t('calc.calcWay1')}}</div>
        </div>
      </div>

    </section>

    <!-- 选择分钱方案 -->
    <Dialog
      ref="Dialog_way"
      :dialogTitle="$t('calc.calcWay2')"
      @close="isCouponOk=true">
      <!-- contentWidth="700"
      :closeable="false" -->
      <div class="mydialog1 df-l-fs" slot="content">
        <div class="info df-c-fs">
          <div class="f-dark f-xs">{{$t('calc.totalPrice')}}：{{orderData.userCost|toprice(2)}}</div>
          <div class="f-dark f-xs" v-if="hasBindCoupon">{{$t('calc.unassigned')}}：{{orderData.unassignCash_|toprice(2)}}</div>
          <div class="f-dark f-xs" v-else>{{$t('calc.unassigned')}}：{{orderData.unassignCash|toprice(2)}}</div>
        </div>
        <el-tabs v-model="activeName">
          <el-tab-pane :label="$t('calc.byPerson')" name="first" :disabled="[6,10].includes(orderData.status)">
            <div class="df-l-c-fs">
              <InputCustom
                class="mb20"
                :inputable="true"
                inputWidth="620"
                inputHeight="50"
                :inputPlaceholder="$t('calc.inputEatCount')"
                :inputValue="personNumber" />
              <Keyboard :inputValue.sync="personNumber" />
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('calc.byCustom')" name="second">
            <div class="df-l-c-fs" style="position:relative;">
              <InputCustom
                class="mb20"
                :inputable="true"
                inputWidth="620"
                inputHeight="50"
                :inputPlaceholder="$t('calc.inputCustomPrice')"
                :inputValue="moneyNumber" />
              <Keyboard :inputValue.sync="moneyNumber" :decimalPlaces="{us:2,hk:1}[sysEnv_x]" priceModel />
              <div class="inputallleftcash df-c-ct" @click="toggleIsInputAllLeftCash">
                <img :src="isInputAllLeftCash?iconCheckok:iconChecknull" style="width:20px;height:20px;margin-right:10px;">
                <div class="f-xs">{{$t('calc.payLeft')}}</div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <template slot="footer">
        <div class="whitebtn" @click="cancelOrderClick" v-if="[8,9,10,100].includes(orderData.status)">{{$t('calc.cancelCalcAndRefund')}}</div>
        <div class="themebtn" @click="calcNumberSubmit">{{$t('common.comfirm')}}</div>
      </template>
    </Dialog>

    <DialogPay ref="DialogPay" @close="clearPayment" />

    <DialogKey ref="DialogKey" />

    <DialogError ref="DialogError" :messages="stockErrorFoods" />

  </div>
</template>

<script>
import { mapState } from 'vuex'
import mixin_print from '@/mixins/mixin_print'
import DialogPay from './components/DialogPay'
import coupon from '@/mixins/coupon'
export default {
  name: 'calcway',
  mixins: [coupon, mixin_print],
  components: { DialogPay },
  data() {
    return {
      activeName: 'first',
      personNumber: '',
      moneyNumber: '',

      
      tableData: {}, // 餐桌
      orderData: {
        partCash: {},
      }, // 订单
      cartItems: [], // 购物车

      isInputAllLeftCash: false,


      moneyNumber_copy: '',
      orderData_new: {
        costOrigin: 0,
        userCost: 0,
        discountFee: 0,
      },

      clearPaymentTimer: null,

      stockErrorFoods: [], // 余量不足

      hasSendCookIds: [],
      timer_timeHandler: null,

      // #region 如果绑定了优惠券，那么该优惠券处理后的价格作为分钱的总金额
      hasBindCoupon: false,
      // #endregion
    }
  },
  computed: {
    ...mapState(['homePage_x']),
    // 订单是否可以绑定刪除优惠券
    isShowCouponChange() {
      return [1,2,3,4].includes(this.orderData.status)
    },
    dialogCash() {
      switch (this.orderData.status) {
        case 3:
        case 5:
        case 6:
        case 8:
        case 10:
          return this.orderData_new.userCost
        default:
          return this.orderData.userCost
      }
    },
    // 根据是否有横纵坐标，判断显示分钱分菜
    isShowOtherCalc() {
      return this.orderData.tableColumn && this.orderData.tableRow
    },

    takeOutPickupDateText() {
      const TIME = this.orderData.takeOutPickupDate
      if (TIME === '-1') {
        return this.$t('menu.now')
      } else if (TIME) {
        return TIME
      } else {
        return ''
      }
    },
  },
  watch: {
    moneyNumber(nval, oval) {
      if (String(this.orderData.unassignCash_) === nval) {
        this.isInputAllLeftCash = true
      } else { 
        this.isInputAllLeftCash = false
      }
    },
  },
  methods: {
    // 分菜 全选剩余金额
    toggleIsInputAllLeftCash() {
      this.isInputAllLeftCash = !this.isInputAllLeftCash
      if (this.isInputAllLeftCash) {
        this.$nextTick(() => {
          this.moneyNumber = String(this.orderData.unassignCash_)
        })
      } else {
        this.$nextTick(() => {
          this.moneyNumber = ''
        })
      }
    },
    
    // 打印
    printOrderClick() {
      if (this.printerId_x) {
        let ticketCodeList = [], rD = {
          shopId: this.currentShopId,
          id: this.orderData.id
        }
        this.coupons.forEach(x => {
          x.code && ticketCodeList.push(x.code)
        })
        ticketCodeList.length > 0 && (rD.ticketCodeList = ticketCodeList)
        
        this.$api.print_order(rD, this.printerId_x).then(res => {
          if (res.status == 0) {
          } else { this._status(res) }
        })
      } else { this.$message.warning(this.$t('print.printerError')) }
    },
    // 选择结算方式 打开结算对话框
    // 先判断是否有售罄
    tapCalcway(type) {
      let rD = {
        shopId: this.currentShopId,
        id: this.orderData.id,
      }
      this.$api.order_calc_before(rD).then(res => {
        if (res.status == 0) {
          let _R = res.data
          if (_R.length) {
            // console.log(`%c_R:`, 'color: #f00;', _R)
            this.stockErrorFoods = _R.map(x => {
              if (x.saleOut) {
                return {
                  text_zh: x.item.name_zh + ' 已售罄',
                  text_en: x.item.name_en + ' is sold out',
                }
              } else {
                return {
                  text_zh: x.item.name_zh + ' 可点数量' + x.availableCount + '份',
                  text_en: x.item.name_en + ' remains ' + x.availableCount + (x.availableCount === 1 ? ' order' : ' orders'),
                }
              }
            })
            this.stockErrorFoods.push({
              text_zh: '请修改数量！',
              text_en: 'please change the quantity !',
            })
            this.$refs.DialogError.open()
          } else {
            if (this.fromPage === 'orderNew' || this.fromPage === 'order') {
              this.autoPrint_mixin(this.orderData.id, this.cartItems, this.hasSendCookIds, () => {
                this.tapCalcway_then(type)
              })
            } else {
              this.tapCalcway_then(type)
            }
          }
        } else { this._status(res) }
      })
    },
    async tapCalcway_then(type) {
      this.hasBindCoupon = false
      this.coupons.forEach(x1 => {
        x1.code && (this.hasBindCoupon = true)
      })

      if (this.isCouponOk) {

        switch (type) {
          case 'money':

            let { orderId, row, column, uniqueCode } = this.tableData
            switch (this.orderData.status) {
              case 1: case 2: case 3:
                this.personNumber = ''
                this.moneyNumber = ''
                this.$refs.Dialog_way.open()
                break
              case 5: case 8:
                await this.calcAveragePriceByServe()
                this.$router.push(`calcwayAvg?oid=${orderId}&sid=${this.currentShopId}&r=${row}&c=${column}&uid=${uniqueCode}`)
                break
              case 6: case 10:
                this.$router.push(`calcwayCus?oid=${orderId}&sid=${this.currentShopId}&r=${row}&c=${column}&uid=${uniqueCode}`)
                break
              case 4: case 7: this.$message.warning(this.$t('calc.haveChosenPayByFood')); break
              case 9: this.$message.warning(this.$t('calc.paidPartByFood')); break
            }

            break;

          case 'food':
            // 已经输入优惠券，只能全部结账！
            if (this.hasBindCoupon) {
              this.$message.warning(this.$t('calc.couponHasInputedOnlyCanCalcAll'))
              return
            }
            // 已经关联了会员，只能全部结账！
            if (this.customer.customerId) {
              this.$message.warning(this.$t('calc.memberHasBoundOnlyCanCalcAll'))
              return
            }
            
            switch (this.orderData.status) {
              case 1: case 2: case 3:
                let rD = {
                  shopId: this.currentShopId,
                  id: this.orderData.id,
                }
                await this.$api.payment_food_enter(rD).then(res => {
                  if (res.status == 0) {
                    let _R = res.data
                    console.log(`%c设置为分菜 订单+状态:`, 'color: #00f;', _R, _R.status)
                    this.orderData.status = _R.status
                  } else { this._status(res) }
                })
              case 4: case 7: case 9:
                let { orderId, row, column, uniqueCode } = this.tableData
                this.$router.push(`calcwayFood?oid=${orderId}&sid=${this.currentShopId}&r=${row}&c=${column}&uid=${uniqueCode}`)
                break
              case 5: this.$message.warning(this.$t('calc.haveChosenPayByPerson')); break
              case 8: this.$message.warning(this.$t('calc.paidPartByPerson')); break
              case 6: this.$message.warning(this.$t('calc.haveChosenPayByCustom')); break
              case 10: this.$message.warning(this.$t('calc.paidPartByCustom')); break
            }

            break;

          case 'pay':
            
            switch (this.orderData.status) {
              case 1: case 2: case 3:
                this.createPayment()
                break
              case 4: case 7: this.$message.warning(this.$t('calc.haveChosenPayByFood')); break
              case 5: this.$message.warning(this.$t('calc.haveChosenPayByPerson')); break
              case 6: this.$message.warning(this.$t('calc.haveChosenPayByCustom')); break
              case 8: this.$message.warning(this.$t('calc.paidPartByPerson')); break
              case 10: this.$message.warning(this.$t('calc.paidPartByCustom')); break
              case 9: this.$message.warning(this.$t('calc.paidPartByFood')); break
            }
            
            break;
        }
      } else {
        this.$message.warning(this.$t('calc.couponError'))
      }
    },
    // 结算对话框 分钱结算 提交数字
    async calcNumberSubmit() {
        
      // #region 如果绑定了优惠券，那么该优惠券处理后的价格作为分钱的总金额
      if (this.hasBindCoupon) {
        let parentTicketCodeList = []
        this.coupons.forEach(x => {
          x.code && parentTicketCodeList.push(x.code)
        })
        const rD = {
          id: this.orderData.id,
          shopId: this.currentShopId,
          parentTicketCodeList,
        }
        await this.$api.order_bind_coupon(rD).then(res => {
          if (res.status == 0) {
            let _R = res.data
            console.log(`%c绑定父订单优惠券的结果:`, 'color: #00f;', _R)
          } else { this._status(res) }
        })
      }
      // #endregion
      
      switch (this.activeName) {
        case 'first':
          // if (this.personNumber) {
          if (Number(this.personNumber) > 20) {
            this.$message.warning(this.$t('calc.personNumberExceedsLimit'))
          } else if (Number(this.personNumber) > 0) {
            const _D1 = await this.setOrderEnterMoney()
            if (_D1 === 'ok') {
              let rD = {
                shopId: this.currentShopId,
                id: this.orderData.id,
                partCash: {
                  persons: this.personNumber,
                },
              }
              const _D2 = await this.sendAjax_OrderConfig(rD)
              if (_D2 === 'ok') {
                await this.calcAveragePriceByServe()
                this.personNumber = ''
                let { orderId, row, column, uniqueCode } = this.tableData
                this.$router.push(`calcwayAvg?oid=${orderId}&sid=${this.currentShopId}&r=${row}&c=${column}&uid=${uniqueCode}`)
              }
            }
          } else {
            this.$message.warning(this.$t('calc.personNumberError'))
          }
          break
        case 'second':
          // console.log(this.moneyNumber)
          if (Number(this.moneyNumber) > 0) {
            if (this.orderData.userCost < this.moneyNumber) {
              this.$message.warning(this.$t('calc.totalError'))
            } else {
              const _D = await this.setOrderEnterMoney()
  
              if (_D === 'ok') {
                // 创建子订单
                this.$api.sub_order_create({
                  shopId: this.currentShopId,
                  orderId: this.orderData.id,
                  userCost: this.moneyNumber
                }).then(res => {
                  if (res.status == 0) {
                    this.moneyNumber = ''
                    let { orderId, row, column, uniqueCode } = this.tableData
                    this.$router.push(`calcwayCus?oid=${orderId}&sid=${this.currentShopId}&r=${row}&c=${column}&uid=${uniqueCode}`)
                  } else { this._status(res) }
                })
              }
            }
          } else {
            this.$message.warning(this.$t('calc.moneyNumberError'))
          }
          break
      }
    },
    // 锁定
    calcAveragePriceByServe() {
      return this.$api.order_item_lock({
        shopId: this.currentShopId,
        orderId: this.orderData.id,
        lockCash: true,
      }).then(res => {
        if (res.status == 0) {
          let _R = res.data
          return _R
        } else { this._status(res) }
      })
    },
    // 结算对话框 分钱结算 提交数字 修改为分钱
    setOrderEnterMoney() {
      if ([1,2,4,7].includes(this.orderData.status)) {
        return this.$api.payment_cash_enter({
          shopId: this.currentShopId,
          id: this.orderData.id,
        }).then(res => {
          if (res.status == 0) {
            let _R = res.data
            this.orderData.status = _R.status
            console.log(`%c设置为分钱 订单+状态:`, 'color: #00f;', _R, _R.status)
            return 'ok'
          } else { this._status(res) }
        })
      } else {
        return new Promise((resolve, reject) => {
          resolve('ok')
        })
      }
    },
    // 结算对话框 分钱结算 提交数字 提交按人数配置
    sendAjax_OrderConfig(rD) {
      return this.$api.payment_cash_config(rD).then(res => {
        if (res.status == 0) {
          let _R = res.data
          console.log(`%c返回的订单+状态:`, 'color: #00f;', _R, _R.status)
          this.orderData = _R
          return 'ok'
        } else { this._status(res) }
      })
    },
    // 继续点餐
    navToMenu() {
      let type = ''
      switch (this.orderData.orderType) {
        case 1: type = 'normal'; break
        case 2: case 4:
          if (this.orderData.takeoutSettingId) {
            type = 'editcustom&payId=' + this.orderData.takeoutSettingId
          } else {
            type = 'edit' // 這裡因為菜單頁面對takeaway進行置空處理，用edit代替判斷
          }
          break
      }
      const URL = `/menu?oid=${this.orderData.id}&type=${type}`
      switch (this.fromPage) {
        case 'menu':
          this.$router.go(-1)
          break
        case 'table':
        case 'order':
        default:
          this.$router.replace(URL)
          break
      }
    },

    // #region 退款
    refundOrderClick() {
      this.$refs.DialogKey.open({
        orderId: this.orderData.id,
        sceneType: 1,
        onConfirm: this.sendAjax_refund,
      })
    },
    async sendAjax_refund() {
      const ORDER = this.orderData
      
      const _Rs = await this.getData('order', {
        parentOrderId: ORDER.id,
        payed: true,
        returnCash: false,
        eftPay: true,
        subOrder: false,
      })
      if (_Rs && _Rs.length) {
        _Rs.forEach(x1 => {
          const { id: orderId, payType, userCost } = x1
          this.sendAjax_eftRefund({ orderId, payType, userCost }).then(() => {
            this.sendAjax_refund_send(ORDER)
          })
        })
      } else {
        console.log('没有支付订单')
        // 如果现金支付过，弹出钱箱
        if (ORDER.payTypeList && ORDER.payTypeList.includes(5)) {
          this.$tool.dsbridge_call(this.$tool.dsbridge_map.openCashDrawer, '')
        }
        this.sendAjax_refund_send(ORDER)
      }
    },
    sendAjax_refund_send(ORDER) {
      let rD = {
        shopId: this.currentShopId,
        id: ORDER.id,
      }
      this.$api.order_refund(rD).then(res => {
        if (res.status == 0) {
          this.$router.go(-1)
        } else { this._status(res) }
      })
    },
    // #endregion

    // #region eft退款
    sendAjax_eftRefund({ orderId, payType, userCost }) {
      return new Promise(async (resolve, reject) => {
        
        let rD = {
          shopId: this.currentShopId,
          orderId,
          payType,
          userCost,
          ip: this.readerId_x,
        }
        console.log(`%cEFT 请求参数:`, 'color: #00f;', rD)

        const RESULT = this.$tool.dsbridge_call(this.$tool.dsbridge_map.eftRefund, rD)
        console.log(`%cEFT result:`, 'color: #00f;', RESULT)
        if (RESULT === 'error') {
          this.$message.error(this.$t('pay.eftRefundFailed'))
          reject()
        } else {
          resolve()
        }
        
      })
    },
    // #endregion

    // #region 撤销
    // 撤销结算
    async cancelOrderClick() {
      await this.judgeCart()
      const { id, status, payTypeList } = this.orderData
      // console.log(`%c撤销订单后id+状态:`, 'color: #00f;', id, status)
      if ([8, 9, 10].includes(status)) {
        this.$refs.DialogKey.open({
          orderId: id,
          sceneType: 1,
          onConfirm: () => {
            // 如果现金支付过，弹出钱箱
            if (payTypeList && payTypeList.includes(5)) {
              this.$tool.dsbridge_call(this.$tool.dsbridge_map.openCashDrawer, '')
            }
            this.sendAjax_cancelCalc()
          }
        })
      } else if (status === 100) {
        this.refundOrderClick()
      } else {
        this.sendAjax_cancelCalc()
      }
    },
    sendAjax_cancelCalc() {
      let rD = {
        shopId: this.currentShopId,
        id: this.orderData.id,
      }
      this.$api.payment_cancel(rD).then(res => {
        if (res.status == 0) {
          this.orderData.status = 1
          this.$refs.Dialog_way.close()
          this.clearOrderCustomer()
          this.judgeCart()
          this.orderCostCalc()
        } else { this._status(res) }
      })
    },
    // #endregion

    // 结算对话框 提交结算方案 打开支付对话框
    createPayment() {
      if (this.isCouponOk) {
        let rD = {
          shopId: this.currentShopId,
          id: this.orderData.id,
        }
        this.$api.payment_pay_enter(rD).then(res => {
          if (res.status == 0) {
            let _R = res.data
            this.orderData.status = _R.status
            console.log(`%cc设置为直接付款 订单+状态:`, 'color: #00f;', _R, _R.status)
            this.$refs.DialogPay.open({
              cash: this.dialogCash,
              poid: this.orderData.id,
              uid: this.customer.customerId || '',
            })
          } else { this._status(res) }
        })
      } else {
        this.$message.warning(this.$t('calc.couponError'))
      }
    },
    // 创建支付订单 paydialog弹框
    createChildOrder(eftPay) {
      let rD = {
        shopId: this.currentShopId,
        orderId: this.orderData.id,
      }
      eftPay && (rD.eftPay = true)
      let ticketCodeList = []

      rD.customerId = this.customer.customerId
      this.coupons.forEach(x => {
        x.code && ticketCodeList.push(x.code)
      })
      ticketCodeList.length > 0 && (rD.ticketCodeList = ticketCodeList)
      return this.$api.payment_create(rD).then(res => {
        if (res.status == 0) {
          let _R = res.data
          // console.log(`%c创建的支付订单:`, 'color: #00f;', _R)
          this.childOrderData = _R
          this.moneyNumber_copy = ''
          return _R.id
        } else { this._status(res) }
      })
    },
    // 支付对话框 关闭支付结果
    async clearPayment() {
      console.log(`%cclearPayment触发了:`, 'color: #f0f;', )
      await this.judgeCart()
      // console.log(this.orderData.status)
      if (this.orderData.status === 100) {
        this.$refs.Dialog_way.close()
        this.$message.success(this.$t('pay.finPay'))

        this.clearPaymentTimer = setTimeout(() => {
          // console.log(`%c主页+上一页:`, 'color: #f00;', this.homePage_x, this.fromPage)
          if (this.homePage_x === 'table') {
            switch (this.fromPage) {
              case 'table': this.$router.go(-1); break
              case 'menu': this.$router.go(-2); break
              case 'order': this.$router.go(-1); break
              default: this.$router.replace('table'); break
            }
          } else if (this.homePage_x === 'menu') {
            switch (this.fromPage) {
              case 'menu': this.$router.go(-1); break
              case 'order': this.$router.go(-1); break
              default: this.$router.replace('menu'); break
            }
          }
          this.clearOrderCustomer()
          clearTimeout(this.clearPaymentTimer)
        }, 2000)
      } else if (!this.isShowNewWindow) {
        // 2023-12-5 17:54:22 支付成功弹框改为绿色消息
        this.$message.success(this.$t('pay.paySuccess'))
      }
    },

    // 判断购物车是否已经存在
    async judgeCart() {
      let { row, column, uniqueCode, orderId } = this.tableData
      let rD = {
        shopId: this.currentShopId,
        filterCheckoutOrderItem: true,
      }
      if (orderId) {
        rD.id = orderId
      } else {
        rD.foodTableKey = `${row}:${column}:${uniqueCode}`
      }
      const _Rs = await this.getData('order', rD)
      
      if (_Rs.length) {
        let _R = _Rs[0]
        this.orderData = _R
        this.cartItems = _R.orderItemDetailList
        console.log(`%c已有的订单+id+状态:`, 'color: #00f;', _R, _R.id, _R.status)
        // console.log(`%c已有的购物车:`, 'color: #00f;', this.cartItems)

        // 当从订单管理跳转，需要填补其他参数
        if (orderId && (!row || !column || !uniqueCode)) {
          this.tableData = {
            row: this.orderData.tableRow,
            column: this.orderData.tableColumn,
            uniqueCode: this.orderData.uniqueCode,
            orderId: this.orderData.id,
          }
        }

        // #region 发送厨房
        this.hasSendCookIds = []
        this.orderData.sendPrinterList.forEach(x => {
          this.hasSendCookIds.push(x.orderItemId)
        })
        // #endregion

        this.isShowTimeOfPlaceOrders && this.timeHandler(_R)

        this.orderCostCalc()

      } else {
        this.orderData = {}
        this.cartItems = []
      }
      return !!_Rs.length
    },

    // #region 处理发送厨房的时间标志
    timeHandler(data) {
      // console.log(`%c22222`, 'color: #f00;',)
      data.orderItemDetailList.forEach(x1 => {
        let CURRENT_TIME = new Date().getTime()
        if (x1.payedTime && x1.payedTime < CURRENT_TIME) {
          CURRENT_TIME = x1.payedTime
        }
        if (this.hasSendCookIds.includes(x1.id) && x1.sendToKitchenTime) {
          let t = Math.floor((CURRENT_TIME - x1.sendToKitchenTime) / 1000 / 60)
          if (t > 999) t = '>999'
          if (t < 0) t = '0'
          this.$set(x1, 'sendToKitchenTimeText_zh', t + '分鐘')
          this.$set(x1, 'sendToKitchenTimeText_en', t + ' Min')
        } else {
          this.$set(x1, 'sendToKitchenTimeText_zh', '')
          this.$set(x1, 'sendToKitchenTimeText_en', '')
        }
      })
    },
    // #endregion

    // 初始化
    async init() {
      let { oid, c, r, uid, open, fromPage } = (this.$route.query)

      this.tableData = {
        row: Number(r),
        column: Number(c),
        uniqueCode: Number(uid),
        orderId: Number(oid)
      }

      await this.judgeCart()
      console.log(`%c进入判断订单状态:`, 'color: #f00;', this.orderData.status)


      if (this.orderData.ticketCodeList && this.orderData.ticketCodeList.length) {
        this.coupons = this.orderData.ticketDiscountFeeList.map(x1 => ({
          desc_zh: x1.name_zh,
          desc_en: x1.name_en,
          code: x1.code,
          status: 0,
          price: x1.fee,
          dis: false,
        }))
        this.orderCostCalc()
      }

      // #region 如果订单已经绑定了会员ID则显示
      if (this.orderData && this.orderData.id && this.orderData.customerId) {
        const { id, customerId } = this.orderData

        const rD = {
          companyId: this.shop_x.companyId,
          id: customerId
        }
        this.$api.user_info_get(rD).then(res => {
          if (res.status == 0) {
            let _Rs = res.data
            if (_Rs.length) {
        
              this.orderBindCustomerCallback({
                orderId: id,
                customerId,
                customerName: _Rs[0].nickName || _Rs[0].name,
              })

            } else {
              this.$message.warning('未查询到顾客信息！')
            }
          } else { this._status(res) }
        })
      }
      // #endregion

      console.log(`%copen:`, 'color: #f00;', open)
      if (open === 'member') {
        this.bindOrderCustomer(oid)
      } else if (open === 'discount') {
        this.openCouponsSelectDialog2()
      }

      fromPage && (this.fromPage = fromPage)
      
      if (this.isShowTimeOfPlaceOrders) {
        this.timer_timeHandler = setInterval(() => {
          this.orderData && this.orderData.id && this.timeHandler(this.orderData)
        }, 1000)
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      vm.fromPage = from.name
      await vm.init()
    })
  },
  beforeRouteLeave(to, from, next) {
    clearTimeout(this.clearPaymentTimer)
    this.activeName = 'first'
    this.personNumber = ''
    this.moneyNumber = ''
    // this.orderData = {
    //   partCash: {},
    // }
    this.orderData_new = {
      userCost: 0,
      discountFee: 0,
    }
    this.$refs.Dialog_way.close()
    this.$refs.DialogPay.close()
    clearInterval(this.timer_timeHandler)
    next()
  }
}
</script>

<style lang='scss' scoped>
// 导航
.section-navs{
  height: 80px;line-height: 80px;background: #fff;padding: 0 10px;margin-bottom: 20px;
  .back-btn{
    padding: 0 10px;width: auto;height: 80px;white-space: nowrap;font-weight: bold;
    .arrow{width: 24px;height: 24px;margin-right: 12px;}
  }
  
  .cancel-btn{margin-left:20px;min-width: 130px;}
  .code{margin-left: 40px;}
}
// 内容
.section-con{
  height: calc(100% - 100px);margin-left: 20px;background: #fff;padding: 20px;overflow: hidden scroll;box-sizing: border-box;
  .section-scroll{
    min-height: 140px;
    overflow: hidden scroll;
    border-bottom: 1px solid #DFDFDF;
    .pad{padding-left: 20px;}
  }
  .section-coupon{
    padding-bottom: 20px;box-sizing: border-box;
    .left{height: 40px;}
    .right{min-width: 280px;}
    .input{
      max-width: 220px;height: 40px;line-height: 40px;box-sizing: border-box;
      border: 1px solid #374978;padding: 0 20px;border-radius: 2px;color: #777;
    }
    .input::placeholder{color: #777;}
    .text{height: 46px;line-height: 46px;flex: 1;text-align: right;}
  }
  .section-items{
    .item{border-top: 1px solid #DFDFDF;padding: 10px 0;}
    .num{width: 60px;margin: 0 60px 0 20px;}
    .timeBox{
      width: 92px;
      span.time{text-align: center;background: #000;color: #fff;border-radius: 4px;padding: 2px 8px;}
    }
    .price{min-width: 180px;text-align: right;}
    .text{line-height: 36px;}
  }
  .section-total{
    min-height: 68px;padding: 0px 20px;
    .text{height: 34px;line-height: 34px;}
    .pad{padding-left: 20px;}
    .remarks{
      max-width: 600px;
      display: -webkit-box;
      word-break: break-all;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .right{min-width: 460px;}
  }
  // .section-waring{margin:20px 0;height: 14px;}
  .section-btns{
    height: 80px;margin: 0 auto;
    .btn{width: 180px;height: 50px;line-height: 50px;}
  }
}
// 选择分钱方案
.mydialog1{
  padding: 0 40px;
  .info{height: 64px;line-height: 64px;}
  .info div:last-child{margin-left: 30px;}
  /deep/.el-tabs{
    display: flex;align-items: center;flex-direction: column;
    .el-tabs__item{font-size: 20px;}
    .el-tabs__item.is-active{background: transparent!important;color: #374978;}
    .el-tabs__active-bar{background-color: #374978;height: 4px;border-radius: 2px;}
    .el-tabs__nav-wrap::after {content: none;}
  }
  .input{
    width: 620px;height: 50px;line-height: 50px;margin-bottom: 20px;padding: 0 20px;text-align: left;
    border: 1px solid #979797;border-radius: 4px;box-sizing: border-box;
    &.active.inputable::after{right: auto;left: 20px;}
  }

  .inputallleftcash{position: absolute;right: 0;top: 90px;}
}
// 按人数分钱 自定义分钱 直接付钱
.mydialog2{
  padding: 0 20px;overflow: hidden scroll;
  .pad{padding-left: 20px;}
  .pad2{padding-right: 20px;}
  .section-coupon{
    padding: 20px 0;box-sizing: border-box;border-bottom: 1px solid #DFDFDF;
    .left{height: 40px;}
    .right{min-width: 280px;}
    .input{max-width: 220px;height: 38px;line-height: 38px;border: 1px solid #374978;padding: 0 20px;border-radius: 2px;color: #777;box-sizing: border-box;}
    .input::placeholder{color: #777;}
    .text{height: 46px;line-height: 46px;flex: 1;margin-right: 20px;text-align: right;}
  }
  .section-calc{
    min-height: 120px;height: auto;padding: 20px 0;
    .info{height: 48px;line-height: 48px;}
    .item{height: 70px;}
    .item-name{height: 28px;line-height: 28px;}
    .item-info{height: 24px;line-height: 24px;}
  }
  .section-total{
    height: 80px;
    .text{height: 34px;line-height: 34px;}
  }
}
// 支付
.mydialog-pay{
  padding: 0 80px;
  .item{width: 180px;height: 200px;}
  .item:nth-child(2n){background: #0ff;}
  .item:nth-child(2n+1){background: #f0f;}

  .pay-result{width:60px;height:60px;border-radius: 50%;padding: 60px;}
  .result-btn{font-size: 18px;margin-top: 120px;}
}
</style>